<!--
 * @Author: Gaho
 * @Date: 2024-03-05 11:10:10
 * @LastEditors: Merlin
 * @LastEditTime: 2025-05-13 15:29:58
 * @Description: 
-->
<template>
    <div class="game-operations">
        <div class="circle-form" v-for="(form, index) in formOptions" :key="index">
            <div class="form-input">
                <div class="input-row">
                    <CurrentCoin class="w-[21px]" />
                    <div
                        class="input-inner"
                    >
                        <input
                            class="input-number"
                            v-model="form.value"
                            :min="0"
                            :max="joinStateStore.hasGameInfoLoaded ? getMaxAmount(form.key) : 0"
                            pattern="^[0-9]{1,9}([.][0-9]{1,8})?$"
                            type="number"
                            inputmode="decimal"
                            :disabled="form.disabled"
                            @blur="$emit('handleFormBtn', 'blur', form)"
                            @input="(e) => onInputBetAmount(e, form)"
                            @focus="(e) => handleFocusEvent(e, form, index)"
                        />
                    </div>
                </div>
                <div class="form-btns">
                    <Button :disabled="form.disabled" @click="$emit('handleFormBtn', '/2', form)"
                        >/2</Button
                    >
                    <Button :disabled="form.disabled" @click="$emit('handleFormBtn', 'x2', form)"
                        >x2</Button
                    >
                    <Button
                        :disabled="form.disabled"
                        @click="$emit('handleFormBtn', 'max', form)"
                        >{{ $t('Max') }}</Button
                    >
                </div>
            </div>
            <!-- 
                ↑ 下注金额输入框 
                ↓ 下注按钮等
            -->
            <div class="input-row mx-[8px]">
                <Toggle
                    :preLabel="$t('autoBet')"
                    v-model="form.auto"
                    :disabled="form.disabled"
                    @update:modelValue="$emit('handleToggle', form)"
                ></Toggle>
            </div>
            <Button
                class="multi-btn"
                :class="setButtonClass(form.key)"
                :disabled="form.disabled"
                @click="$emit('handleBet', form)"
            >
                <!-- 禁止下注时(form.disabled=true)显示的动画 -->
                <div class="spinner-md spinner" v-if="form.disabled">
                    <span class="spinner-bounce"></span>
                    <span class="spinner-bounce"></span>
                    <span class="spinner-bounce"></span>
                </div>
                <!-- 
                    打开自动下注开关时(form.auto=true)
                    并且没有确认下注(form.isSubmiting=false)
                    并且当前非禁止下注状态(form.disabled=false)
                    显示的按钮内容 
                -->
                <span v-if="form.auto && !form.isSubmiting && !form.disabled">
                    {{ $t('startAuto') }}
                </span>
                <!-- 
                    打开自动下注开关时(form.auto=true)
                    并且已确认下注(form.isSubmiting=true)
                    并且当前非禁止下注状态(form.disabled=false)
                    显示的按钮内容 
                -->
                <span v-if="form.auto && form.isSubmiting && !form.disabled">
                    {{ $t('stopAuto') }}
                </span>
                <div class="lds-dual-ring ml-1" v-if="form.auto && form.isSubmiting && !form.disabled">
                    <div class="lds-dual-ring-after"></div>
                </div>
                <!-- 
                    关闭自动下注开关时(form.auto=false)
                    并且当前非禁止下注状态(form.disabled=false)
                    显示的按钮内容 
                -->
                <!-- ↓ 这是下注按钮，关键元素 -->
                <span v-if="!form.disabled && !form.auto">
                    {{ form.multi?.toFixed(2) }}X
                </span>
            </Button>
        </div>
        <!-- 选择筹码列表 -->
        <CasinoBetOptionSectionChipList
            v-if="inputRef?.length && currentForm"
            v-model="currentForm.value"
            @amountSetter="$emit('handleFormBtn', 'chips', currentForm)"
            :input="inputRef[currentIndex]"
            :currentFormOption="currentForm"
            :disabled="currentForm.disabled"
        />
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
// stores
import useSettingsStore from '@/stores/settings';
import { useUserStore } from '~/stores/user';
// mock data
import { type formType } from '../../data';
import betHelper from '@/common/js/betHelper';
import { useJoinStateStore } from '~/stores/cansino/joinState';

export default defineComponent({
    name: 'circleForm',
    props: {
        formOptions: {
            type: Array<formType>,
            default: () => []
        },
        circleState: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            joinStateStore: useJoinStateStore(),
            settingStore: useSettingsStore(),
            timer: null,
            clickTime: 0, // 记录当前点击时间
            inputRef: null, // 记录当前点击的input元素
            userStore: useUserStore(),
            currentForm: null,
            currentIndex: null,
        }
    },
    computed: {
        currentCurrency(){
            return this.settingStore.pickedCurrency || 'btc';
        }
    },
    mounted(){
        this.$nextTick(() => {
            const aInput = [...document.querySelectorAll('.circle-form input.input-number')];
            // console.log('aInput', aInput); 
            this.inputRef = shallowRef(aInput);
        }); 
    },
    methods: {
        /**
         * 设置按钮的class样式
         */
        setButtonClass(color: string){
            let typeClass = '';
            switch(color){
                case 'gray':
                    typeClass = 'btn-grey';
                break;
                case 'red':
                    typeClass = 'btn-red';
                break;
                case 'green':
                    typeClass = 'btn-green';
                break;
                case 'yellow':
                    typeClass = 'btn-yellow';
                break;
                default:
                    typeClass = 'btn-grey';
            }
            return typeClass;
        },
        /**
         * 因为触发不了双击事件，所以用点击事件间隔模拟双击事件
         * @param e 
         */
        handleFocusEvent(e, form, index){
            this.currentForm = form,
            this.currentIndex = index;
        },
        /**
         * input事件
         * @param ev 
         * @param form 
         */
        onInputBetAmount(ev: any, form: formType){
            const { key } = form;
            if (ev.target.value.length > 9) {
                ev.target.value = ev.target.value.slice(0, 8);
                return;
            }
            const [maxValue, toast] = betHelper.onMaxClick({
                currentBalance: this.userStore.oNowCurrency.balance,
                maxBetAmount: betHelper.getMaxBetAmout(1, key),
            });
            if (Number(ev.target.value) > 0){
                showToastIfNeeded(toast);
            }
            if (Number(ev.target.value) >= maxValue) {
                const result = maxValue.toString().slice(0, 8);
                this.$emit('handleFormBtn', 'input', form, result.toString())
                return;
            }
            this.$emit('handleFormBtn', 'input', form, ev.target.value.toString())
        },
        /**
         * 获取form最大下注金额
         * @param key 不同下注类型
         */
        getMaxAmount(key: string){
            return betHelper.onMaxClick({
                currentBalance: this.userStore.oNowCurrency.balance,
                maxBetAmount: betHelper.getMaxBetAmout(1, key),
                minBetAmount: betHelper.getMinBetAmout(key),
            })[0]; 
        },
    }
})
</script>

<style lang="scss" scoped>
.game-operations {
    display: flex;
    flex-wrap: wrap;
    height: auto;
    justify-content: space-between;
    position: relative;
    width: auto;
    gap: 10px;
    user-select: none;
}
.circle-form {
    display: grid;
    grid-template-columns: 5fr 1fr 2fr;
    width: 100%;
    @media (max-width: 500px) {
        width: 100%;
    }

    .form-input {
        align-items: center;
        background: #161f2c;
        border: 1px solid #4b5b74;
        border-radius: 10px;
        box-sizing: border-box;
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        justify-content: center;
        align-items: center;
        padding: 12px;
        position: relative;
        @media (max-width: 1200px) {
            padding: 3px 5px;
        }

        .input-row-usdt {
            color: rgb(85, 101, 126);
            font-size: 14px;
            line-height: 11px;
            text-transform: uppercase;
            margin-bottom: 5px;
            align-items: center;
            display: inline-flex;
            flex-shrink: 0;
            font-weight: 600;
            letter-spacing: -0.5px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }
    .input-row {
        align-items: center;
        display: flex;
        justify-content: center;

        .input-inner {
            flex: 1;
            margin-left: 4px;
            .input-number {
                color: #fff;
                font-size: 15px;
                font-style: normal;
                font-weight: 600;
                line-height: 22px;
                background-color: transparent;
                border: none;
                outline: none;
                height: 30px;
                // width: 80px;
                width: 100%;
                text-align: center;
            }
        }
        :deep(.toggle-tool) {
            flex-direction: column;
        }
    }
    .form-btns {
        display: flex;
        button {
            background-color: #283343;
            border: none;
            border-radius: 7px;
            color: #6e7c8a;
            font-size: 12px;
            font-weight: 700;
            padding: 0 4px;
            touch-action: manipulation;
            transition: all 0.3s;
            // min-width: 30px;
            flex: 1;
            height: 35px;
            &:nth-child(1) {
                @media (max-width: 950px) {
                    margin-right: 0;
                }
            }
            &:nth-child(2) {
                margin: 0 4px;
            }
            &:hover {
                color: #fff;
            }
            @media (max-width: 568px) {
                font-size: 10px;
                padding: 0 2px;
            }
        }
    }
    .multi-btn {
        border-radius: 10px;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 22px;
        min-height: 50px;
        overflow-x: hidden;
        padding: 14px 8px;
        position: relative;
        text-overflow: ellipsis;
        transition: background-color 0.3s, box-shadow 0.3s;
        white-space: nowrap;
        color: #fff;
        flex: 1;
        &:disabled {
            opacity: 0.5;
            pointer-events: none;
        }
    }
    .btn-grey {
        background-color: #343f5a;
        &:hover {
            background-color: #3d4a6a;
        }
    }
    .btn-red {
        background-color: #ed1d49;
        &:hover {
            background-color: #fb4970;
        }
    }
    .btn-green {
        background-color: #1bb83d;
        &:hover {
            background-color: #47d960;
        }
    }
    .btn-yellow {
        background-color: #ffb636;
        color: #0d131c;
        &:hover {
            background-color: #ffdc19;
        }
    }
}
.spinner {
    display: flex;
    left: 50%;
    min-height: 22px;
    min-width: 22px;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
    .spinner-bounce {
        animation: bouncedelay 1.2s ease-in-out infinite both;
        background-color: #fff;
        border-radius: 100%;
        display: inline-block;
        &:first-child {
            animation-delay: -0.32s;
        }
        &:nth-child(2) {
            animation-delay: -0.16s;
        }
    }
}

.spinner-sm .spinner-bounce {
    height: 6px;
    margin: 0 2px;
    width: 6px;
}

.spinner-md .spinner-bounce {
    height: 8px;
    margin: 0 3px;
    width: 8px;
}

.spinner-lg .spinner-bounce {
    height: 10px;
    margin: 0 4px;
    width: 10px;
}
.lds-dual-ring {
    display: inline-block;
}

.lds-dual-ring-after {
    animation: lds-dual-ring 1.2s linear infinite;
    border: 3px solid #fff;
    border-radius: 50%;
    content: ' ';
    display: block;
    height: 13px;
    margin: 1px;
    width: 13px;
    border-color: rgb(255, 255, 255) transparent;
}

@keyframes lds-dual-ring {
    0% {
        transform: rotate(0);
    }

    to {
        transform: rotate(1turn);
    }
}

@keyframes bouncedelay {
    0%,
    80%,
    to {
        transform: scale(0);
    }

    40% {
        transform: scale(1);
    }
}
</style>